import ShopSameDayMain from 'components/ShopYourStore/ShopSameDayMain/ShopSameDayMain';
import { withShopSameDayMainProps } from 'components/ShopYourStore/ShopSameDayMain/withShopSameDayMainProps';

export default withShopSameDayMainProps(ShopSameDayMain);
